import { VALIDATION } from "../constants";

export const isValidMobile = (mobile) => !VALIDATION || /^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$/.test(mobile);
export const isValidLandline = (landline) => !VALIDATION || /^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$/.test(landline);
export const isValidEmail = (email) => !VALIDATION || /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(email);



export const formatDecimalNumber = (num) => {
  return Number?.isInteger(num) ? num?.toFixed(0) : num?.toFixed(2);
};